export const getStorySection = (story) => {
  if (story?.section) {
    return story.section;
  }
  return "breaking";
};

export const getStoryDisplayTitle = (story) => {
  return (story?.headline || "")
    .replace("[BREAKING]", "")
    .replace("[SPORTS]", "")
    .replace("[EDITORIAL]", "")
    .trim();
};

export const getStorySectionLabel = (section) => {
  if (section === "crime") {
    return "Crime";
  }
  if (section === "public-safety") {
    return "Public Safety";
  }
  if (section === "politics") {
    return "Politics";
  }
  if (section === "investigations") {
    return "Investigations";
  }
  if (section === "public-records") {
    return "Public Records";
  }
  if (section === "community") {
    return "Community";
  }
  if (section === "weather") {
    return "Weather";
  }
  if (section === "traffic") {
    return "Traffic";
  }
  if (section === "videos") {
    return "Videos";
  }
  if (section === "live") {
    return "Live";
  }
  if (section === "government") {
    return "Government";
  }
  if (section === "education") {
    return "Education";
  }
  if (section === "courts") {
    return "Courts";
  }
  if (section === "consumer-alerts") {
    return "Consumer Alerts";
  }
  if (section === "houston-news") {
    return "Houston News";
  }
  if (section === "texas-news") {
    return "Texas News";
  }
  if (section === "sports") {
    return "Sports";
  }
  if (section === "editorial") {
    return "What’s New";
  }
  return "Breaking News";
};